'use strict';
import moment from "moment";
import _, { keyBy } from 'lodash';
import {bindShallow} from "../../uiMigration/bindAngularWithMobx";
import SelectedLocationsStore from '../../services/locations/SelectedLocationsStore';
import ProvidersStore from "../../services/providers/ProvidersStore";
import * as mobx from 'mobx';
import listingFilterStore from "../../modules/listings/ListingFilterStore";
import {listActiveGoogleVerifications} from "../../modules/listings/components/GoogleListingVerification-api";

angular.module('clientDashboardApp').controller("ListingCtrl",
    function (
      $scope, $rootScope, $log, $location, $state, $uibModal, $timeout, $q,
      listingService, searchService, locationService, reactContainer
    ) {

        $scope.noteSettings = {type: "Listings", userInfo: $scope.userInfo}
        $scope.hideForRefresh = false
        $scope.listingLocationsLoaded = false
        $scope.columns = reactContainer.getContainer().columns;
        $scope.loadingResults = true;

        $rootScope.$on('listing:updateIgnoredMismatchTypes', () => {
          if (reactContainer.getContainer().reportType === 'Summary') {
            listingService.listingReportOld($scope.searchConfig.groupId, $scope.reportOptions).then(updateSearchResults);
          } else {
            listingService.listingReport(reactContainer.getContainer().reportType, $scope.searchConfig.groupId, $scope.reportOptions).then(updateReport);
          }
        })

        // TODO - some sucky interactions between scope watching, location and other url changes that cause lots of
        // duplicate interactions. Just debounce
        const searchDebounced = _.debounce(() => $scope.checkAndExecuteSearch(true), 200);
        $scope.checkAndExecuteSearch = function (validForm) {
            if (!validForm || !reactContainer.getContainer()) return;
            $scope.loadingResults = true;
            $scope.searchResults = {};
            $scope.activeGoogleVerifications = [];
            $scope.listingSummary = null;

            var filter = {};
            filter.groupId = $scope.searchConfig.groupId;
            $scope.listingSearchOptions.startDate = null;
            $scope.listingSearchOptions.endDate = null;
            $scope.listingSearchOptions.providers = null;

            if ($scope.searchConfig.providers) {
                filter.providers = $scope.searchConfig.providers.join();
                $scope.reportProviders = $scope.searchConfig.providers;
            } else {
                $scope.reportProviders = $scope.providers;
            }

            $scope.reportOptions = {};
            angular.extend($scope.reportOptions, filter);

            $scope.reportType = reactContainer.getContainer().reportType;
            $scope.reportOptions.reportType = $scope.reportType;
            if (reactContainer.getContainer().reportType === 'Summary') {
                angular.extend($scope.listingSearchOptions, filter);
                searchService.searchListings($scope.listingSearchOptions)
                    .then(searchResponse => {
                        const googleListingsIds = searchResponse.results
                            .filter(listing => listing.contentProvider === "GOOGLE")
                            .map(listing => listing.listingId);

                        listActiveGoogleVerifications(googleListingsIds)
                            .then(activeGoogleVerifications => {
                                updateListingsTable(searchResponse, activeGoogleVerifications)
                            })
                    });
                listingService.listingReportOld($scope.searchConfig.groupId, filter).then(updateSearchResults);
            } else {
                listingService.listingReport(reactContainer.getContainer().reportType, $scope.searchConfig.groupId, filter).then(updateReport);
            }
        };

        $scope.locationSummaries = {};

        $scope.listingMatchConfig = {};

        $scope.listingMatchConfig.onLocationUpdate = (location) => {
          const copy = angular.copy($scope.searchResults.results)
          delete $scope.searchResults.results
          /* force the listing-match directive to render new data */
          $scope.searchResults.results = $scope.listingsWithUpdatedLocations(copy, location)
        }

        $scope.listingsWithUpdatedLocations = (listings, updatedLocation) => {
          return listings.map( listing => {
            const location = listing.location.locationId === updatedLocation.id ? locationAdaptedForListing(listing.location,updatedLocation) : listing.location
            return {
              ...listing,
              location,
              bestListing: listing.bestListing ? {
                ...listing.bestListing,
                location
              } : null
            }
          })
        }

        function locationAdaptedForListing (original,updated) {
          return {
            ...original,
            businessName: updated && updated.busName || original.busName,
            businessAddress: updated && updated.address || original.address,
            phoneNumber: [updated && updated.primaryPhone || original.primaryPhone]
          }
        }

        $scope.locationSummary = function (locationId) {
            locationService.locationSummary(locationId).then(function (result) {
                $scope.locationSummaries[result.locationId] = result.summary;
            });
        };

        $scope.hasErrorMatch = function (types, listing) {
            var matchErrors = listing.matchErrors;
            if (!matchErrors) {
                return false;
            }

            for (var i = 0; i < matchErrors.length; i++) {
                for (var j = 0; j < types.length; j++) {
                    if (matchErrors[i] === types[j]) {
                        return true;
                    }
                }
            }
            return false;
        };

        $scope.formatFoundStreet = function (foundAddress) {
            var street = '';
            var suite = '';

            if (foundAddress.street) {
                street = foundAddress.street;
            }

            if (foundAddress.suite) {
                suite = foundAddress.suite;
            }
            if (street.length > 0) {
                street += ', ';
            }
            if (suite.length > 0) {
                street += ', ';
            }

            return street.trim();
        };

        $scope.formatFoundStateAndCity = function (foundAddress) {
            var cityAndState = '';

            if (foundAddress.city) {
                cityAndState = foundAddress.city + ', ';
            }
            if (foundAddress.state) {
                cityAndState += foundAddress.state + ' ';
            }
            if (foundAddress.postalCode) {
                cityAndState += foundAddress.postalCode + ', ';
            }

            //Remove trailing comma
            if (cityAndState.length > 0) {
                cityAndState = cityAndState.substring(0, cityAndState.length - 1)
            }
            return cityAndState.trim()
        };

        /*
         ** Summary report
         */

        var updateReport = function (reportResponse) {
            $scope.reportExportHandle = reportResponse;
            $scope.report = reportResponse.results;
            $scope.loadingResults = false;
        };

        var updateSearchResults = function (searchResponse) {
            $scope.listingSummaryExportHandle = searchResponse;
            $scope.listingSummary = searchResponse.results;
            $scope.loadingResults = false;
        };

        var updateListingsTable = function (searchResponse, maybeActiveGoogleVerifications) {

            for (var i = 0; i < searchResponse.results.length; i++) {
                // some of our listing scrapers allow duplicate category values. Fixed for yelp
                searchResponse.results[i].categories = _.uniq(searchResponse.results[i].categories)

                var locationId = searchResponse.results[i].locationId;

                locationService.locationSummary(locationId).then(function (result) {
                    $scope.locationSummaries[result.locationId] = result.summary;
                });
            }

            $scope.searchResults = searchResponse

            $scope.listingLocationsLoaded = false

            $scope.listingsWithLocations($scope.searchResults.results).then( withLocations => {
              const activeGoogleVerifications = maybeActiveGoogleVerifications || [];
              $scope.searchResults.results = withLocations
              $scope.activeGoogleVerifications = $scope.activeGoogleVerifications.concat(activeGoogleVerifications);
              $scope.loadingListings = false;
              $scope.listingLocationsLoaded = true
            })

        };

        $scope.listingsWithLocations = (listings) => {
          const locationIds = _.uniq(listings.map(listing => listing.locationId))
          let promises = []

          locationIds.forEach( locationId => {
            promises.push(locationService.getLocation(locationId.replace('legacy-',''))) /*TODO We need a location endpoint that accepts a set of locationIds*/
          })

          return $q.all(promises).then(resp => {
            return listings.map( listing => {
              const location = resp.find(location => location.locationId.replace('legacy-','') === (listing.locationId.replace('legacy-','')))

              return {
                ...listing,
                location,
                bestListing: listing.bestListing ? {
                  ...listing.bestListing,
                  location
                } : null
              }
            })
          })
        }

        $scope.calculateTotal = function (reportData, column) {
          if (!reportData) return 0;

          let total = 0;
          for (let i = 0; i < reportData.length; i++) {
            let results = reportData[i].results ? reportData[i].results : reportData[i];
            let newVal = results[column];
            if (newVal && newVal !== -1) {
              total += newVal
            }
          }
          return total;
        };

        //Default Sort Settings
        $scope.sortField = 'provider';
        $scope.reverseSortOrder = false;

        $scope.sortReportTable = function (newSortField) {
            if ($scope.sortField === newSortField) {
                $scope.reverseSortOrder = !$scope.reverseSortOrder;
            } else {
                $scope.sortField = newSortField
            }
        };

        $scope.getReportSortIcon = function (column) {
            if ($scope.sortField === column) {
                if ($scope.reverseSortOrder) {
                    return 'fa-sort-down';
                } else {
                    return 'fa-sort-up';
                }
            } else {
                return 'fa-sort';
            }
        };

        $scope.listingDrillDown = function (provider, reportColumn) {

        };

        $scope.changeClass = function (providerId, type) {
            var newCount = getLatestResult(providerId, type);
            if (!angular.isDefined(newCount)) {
                return '';
            }

            var oldCount = getPreviousResult(providerId, type);
            if (!angular.isDefined(oldCount) || (oldCount === 0 && newCount !== oldCount)) {
                return 'new';
            }

            var change = newCount - oldCount;

            if (change > 0) {
                return 'higher'
            } else if (change < 0) {
                return 'lower'
            } else if (change === 0) {
                return 'same'
            }
        };

        var getPreviousResult = function (providerId, type) {
            for (var i = 0; i < $scope.listingSummary.previousProviderReport.length; i++) {
                var listingSummary = $scope.listingSummary.previousProviderReport[i];
                if (listingSummary.provider === providerId && angular.isDefined(listingSummary[type])) {
                    return listingSummary[type];
                }
            }
        };

        var getLatestResult = function (providerId, type) {
            for (var i = 0; i < $scope.listingSummary.latestProviderReport.length; i++) {
                var listingSummary = $scope.listingSummary.latestProviderReport[i];
                if (listingSummary.provider === providerId && angular.isDefined(listingSummary[type])) {
                    return listingSummary[type];
                }
            }
        };

        $scope.formatChange = function (provider, type) {
            var change = $scope.calculateChange(provider, type);
            return change + '%';
        };

        $scope.calculateChange = function (provider, type) {
            var newCount = getLatestResult(provider, type);
            if (!angular.isDefined(newCount)) {
                return;
            }

            var oldCount = getPreviousResult(provider, type);
            if (!angular.isDefined(oldCount)) {
                return;
            }

            if (newCount === oldCount) {
                return 0;
            }

            var change = Math.round((newCount / oldCount - 1) * 100);

            if (change >= 0) {
                return change;
            } else if (change < 0) {
                return change * -1;
            }
        };

        $scope.listingSearchOptions = {limit: 10, sortField: "lastUpdated", sortOrder: "DESC"};

        $scope.getSortIcon = function (column) {
            if ($scope.listingSearchOptions.sortField === column) {
                if ($scope.listingSearchOptions.sortOrder === 'ASC') {
                    return 'fa-sort-up';
                } else {
                    return 'fa-sort-down';
                }
            } else {
                return 'fa-sort';
            }
        };

        $scope.sortListingsTable = function (sortColumn, searchResult) {
            if ($scope.listingSearchOptions.sortField === sortColumn) {
                if ($scope.listingSearchOptions.sortOrder === 'ASC') {
                    $scope.listingSearchOptions.sortOrder = 'DESC';
                } else {
                    $scope.listingSearchOptions.sortOrder = 'ASC';
                }
            } else {
                $scope.listingSearchOptions.sortField = sortColumn;
                $scope.listingSearchOptions.sortOrder = 'DESC';
            }
            searchResult.sortResults($scope.listingSearchOptions.sortField, $scope.listingSearchOptions.sortOrder);
        };

        $scope.hasMoreResults = function (searchResult) {
            return searchResult && searchResult.hasMoreResults && searchResult.hasMoreResults();
        };

        $scope.hasAnyResults = function (searchResult) {
            return searchResult && searchResult.hasAnyResults && searchResult.hasAnyResults();
        };

        $scope.loadingListings = false;
        $scope.loadMoreResults = function (searchResult) {
            if (!searchResult || $scope.loadingListings || !$scope.hasMoreResults(searchResult)) {
                //We are already awaiting results
                return;
            }
            $scope.loadingListings = true;
            searchResult.loadMoreResults(10).then(searchResponse => {
                if (reactContainer.getContainer().reportType === 'Summary') {
                    const googleListingsIds = searchResponse.results
                        .filter(listing => listing.contentProvider === "GOOGLE")
                        .map(listing => listing.listingId);

                    listActiveGoogleVerifications(googleListingsIds)
                        .then(activeGoogleVerifications => {
                            updateListingsTable(searchResponse, activeGoogleVerifications)
                        })
                } else {
                    updateListingsTable(searchResponse)
                }
            });
        };

        $scope.notMinePopup = function () {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance' , function ($scope, $uibModalInstance) {
                $scope.ok = function () {
                    $uibModalInstance.close(true);
                };

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            }];

            var modalInstance = $uibModal.open({
                template: require('./notMineModal.html'),
                controller: ModalInstanceCtrl
            });

            modalInstance.result.then(function (confirmIgnore) {
                if (confirmIgnore) {
                    //Mark as not mine
                }
            }, function () {
            });
        };


        $scope.searchConfig = {};
        bindShallow($scope, $scope.searchConfig, listingFilterStore.state, {
          initializeFromMobx: true,
          mobxToAngular: ({ groupId, ...rest }) => rest,
        });
        $scope.$on(
          "$destroy",
          mobx.reaction(
            () => SelectedLocationsStore.legacyGroupIdOrAll,
            (groupId) => ($scope.searchConfig.groupId = groupId),
            {
              fireImmediately: true,
            }
          )
        );


        $scope.$watch("searchConfig", function (newConfig) {
          /*
           Build location path
           */
          var newSearchParams = {
            groupId: newConfig.groupId,
            reportType: reactContainer.getContainer().reportType,
          };

          //Only set providers if we actually have some
          if (newConfig.providers && newConfig.providers.length > 0) {
            newSearchParams.providers = newConfig.providers;
          }

          searchDebounced();

          $scope.allResults = searchService.withExportConfig("listings", newSearchParams);

        }, true);


        $scope.refreshReport = function() {
          setInitialReport($scope.searchConfig.groupId);
          $scope.checkAndExecuteSearch(true);
        }

        $scope.urlWithParam = function (paramName, paramValue) {
            //To save building URL and encoding params from scratch.
            //Update angular search params, grab url and then reset.
            var urlBefore = $location.url();
            $location.search(paramName, paramValue);
            var newUrl = $location.absUrl();
            $location.url(urlBefore);
            return newUrl;
        };

    });
